<template>
  <el-dialog title="分享作品" :visible.sync="visible" custom-class="share-dialog" class="global-dialog" width="640px">
    <div class="title">您将要分享作品：{{shareItem.name}}</div>
    <div class="tip">复制以下文字发送给需要查看的人</div>
    <div>
      <span @click="copyWork" class="content" :class="{'copy' : show}"><span>点击查看我的作品：{{url}}</span></span>
      <el-button class="btn" @click="copyWork" type="primary">复制</el-button>
    </div>
    <transition name="fade">
      <div class="info-success" v-if="show">
        <i class="el-icon-success"></i>
        复制成功
      </div>
    </transition>
  </el-dialog>
</template>
<script>
export default {
  props: {
    value: {type:Boolean, default: false},
    shareItem: {type: Object, default: null},
  },
  data () {
    return {
      url: '',
      id: this.shareItem.id,
      show: false,
    }
  },
  created () {
    let origin = window.location.origin;
    let item = this.shareItem;
    this.url = `${origin}/#/share/${this.id}?projectId=${item.projectId}&type=${item.type}`
  },
  computed: {
    visible: {
      get () {
        return this.value;
      },
      set (val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    copyWork () {
      const input = document.createElement('input');
      this.show = true;
      setTimeout(() => {
        this.show = false;
      }, 2000);
      document.body.appendChild(input);
      input.setAttribute('value', this.url);
      input.select();
      if (document.execCommand('copy')) {
          document.execCommand('copy');
      }
    }
  }
}
</script>

